import { Map, List } from 'immutable'

import {
  SET_CONNECTORS,
  SET_ENABLED_INTEGRATIONS,
  SET_INTEGRATION_STREAMS,
  SET_INTEGRATION_TYPES,
  SET_S3_UPLOAD_PROGRESS,
  SET_OUTBOUND_INTEGRATION,
  SET_INTEGRATION_LOADER,
  INTEGRATION_STREAMS_LOADER
} from '../actions/integrationActions'

export const initialState = new Map({
  integration_types: new List(),
  loaded: false,
  available_behaviors: new List(),
  enabled_integrations: new List(),
  enabled_vendors: new List(),
  connectors: new List(),
  integration_streams: new List(),
  integration_streams_loader: true,
  outbound_integration: [],
  integration_loader: true
})

const integrationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_INTEGRATION_TYPES:
      return state
        .set('integration_types', action.data.integration_list)
        .set('loaded', true)
        .set('available_behaviors', action.data.available_behaviors)
    case SET_ENABLED_INTEGRATIONS:
      return state.set('enabled_vendors', action.data)
    case SET_CONNECTORS:
      return state.set('connectors', action.data)
    case SET_OUTBOUND_INTEGRATION:
      return state.set('outbound_integration', action.data)
    case SET_INTEGRATION_STREAMS:
      return state.set('integration_streams', action.data).set('integration_streams_loader', false)
    case SET_INTEGRATION_LOADER:
      return state.set('integration_loader', action.data)
    case INTEGRATION_STREAMS_LOADER:
      return state.set('integration_streams_loader', action.data)
    case SET_S3_UPLOAD_PROGRESS:
      if (action.data.total === 0) {
        // This will trigger if the user uploads a completely empty file.
        return state.set('percentCompleted', 100)
      }
      return state.set(
        'percentCompleted',
        Math.round((action.data.loaded * 100) / action.data.total)
      )
    default:
      return state
  }
}

export default integrationReducer
